import styled, { css } from 'styled-components';
import { PlayBlobContainer, PlayIconContainer } from 'src/components';
import { CircleStage } from 'src/apps/Path/pathCelebrationStyles';

export const LearnablesList = styled.ul(
  ({ theme }) => css`
    margin: ${theme.sz.s0};
    padding: ${theme.sz.s0};
    list-style-type: none;
    width: 100%;
  `,
);

export const LearnablesListItem = styled.li(
  ({ theme }) => css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: ${theme.sz.s4};
    align-items: baseline;
    padding: ${theme.sz.s4} 0;
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary95};

    @media (max-width: ${theme.sz.md}) {
      grid-template-columns: 1fr;
    }
  `,
);

export const LearnableSource = styled.div(
  ({ theme }) => css`
    text-align: start;
    color: ${theme.co.secondary50};
    ${theme.typography.paragraph.s};
  `,
);

export const LearnableTarget = styled.div(
  ({ theme }) => css`
    text-align: start;
    ${theme.typography.heading.desktop.xxxs};
  `,
);

export const NotEnoughLearnablesLayout = styled.div(
  ({ theme }) => css`
    max-width: ${theme.sz.xs};
  `,
);

export const NotEnoughLearnablesText = styled.div(
  ({ theme }) => css`
    text-align: center;
    ${theme.typography.heading.desktop.xxs};
    margin-bottom: ${theme.sz.s6};
  `,
);

export const VideoStage = styled(CircleStage)(
  ({ theme }) => css`
    width: 100%;

    > * {
      width: 100%;
      height: 100%;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 0;
    }

    ${PlayBlobContainer} {
      display: none;
    }

    ${PlayIconContainer} {
      width: 22%;
    }

    /* The blob usually carries the focus ring, so the button needs its own once hidden. */
    button:focus-visible {
      outline: ${theme.bo.mediumWidth} solid ${theme.co.information50};
      outline-offset: -${theme.bo.thickWidth};
    }
  `,
);
